/* Fantasy Forged - game-aware search for the Refresh theme.
 * Loaded once per page from snippets/header-search.liquid (its Search-In-Modal instance), which also emits the game
 * table as JSON in #ff-games-json (rendered by snippets/ff-game-context.liquid, mode: 'json').
 *
 * What it does:
 *  1. Wires the "Only <game>" and "In stock only" toggles to the hidden inputs in each search form.
 *  2. Scopes the predictive (dropdown) search to the game with a q qualifier, e.g.
 *     (product_type:"MTG Single" OR product_type:"MTG Sealed") bolt   - the full results page uses filter.* params instead.
 *  3. Expands old links like /search?q=x&game=mtg into the filter params the results page understands, and keeps the
 *     facet forms products-only.
 *  4. Drives the Advanced Search page (game pills, links, ?game= preselect).
 *  5. Keeps the results page (pills, title, search box) in step with the URL after facets re-render the grid.
 */
(function () {
  'use strict';
  if (window.ffSearchLoaded) return;
  window.ffSearchLoaded = true;

  var STORAGE_KEY = 'ff:search:instock';
  var ALIASES = {
    magic: 'mtg', 'magic-the-gathering': 'mtg', magicthegathering: 'mtg',
    'pokémon': 'pokemon', pkmn: 'pokemon',
    ygo: 'yugioh', 'yu-gi-oh': 'yugioh', yugioh: 'yugioh',
    'one-piece': 'onepiece', onepiece: 'onepiece',
    fleshandblood: 'fab', 'flesh-and-blood': 'fab', flesh_and_blood: 'fab',
    starwars: 'swu', 'star-wars-unlimited': 'swu', starwarsunlimited: 'swu'
  };

  var games = [];
  try {
    var node = document.getElementById('ff-games-json');
    games = node ? JSON.parse(node.textContent || '[]') : [];
  } catch (e) { games = []; }

  function gameByKey(raw) {
    if (!raw) return null;
    var k = String(raw).toLowerCase();
    var key = ALIASES[k] || k;
    for (var i = 0; i < games.length; i++) if (games[i].key === key) return games[i];
    return null;
  }

  function readInstockPref() {
    try { return localStorage.getItem(STORAGE_KEY) !== '0'; } catch (e) { return true; }
  }
  function writeInstockPref(on) {
    try { localStorage.setItem(STORAGE_KEY, on ? '1' : '0'); } catch (e) { /* ignore */ }
  }
  /* the last game the shopper was in, offered (switched off) on pages that belong to no game */
  var GAME_KEY = 'ff:search:game';
  function readGamePref() {
    try { return localStorage.getItem(GAME_KEY) || ''; } catch (e) { return ''; }
  }
  function writeGamePref(key) {
    try { if (key) localStorage.setItem(GAME_KEY, key); } catch (e) { /* ignore */ }
  }
  function urlInstock(sp) {
    return sp.getAll('filter.v.availability').indexOf('1') !== -1;
  }
  function htmlEscape(s) {
    return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* Qualifier for the predictive endpoint only. Parenthesised so the results markup can be cleaned up. */
  function qualifierFor(types, vendor) {
    if (types.length) return '(' + types.map(function (t) { return 'product_type:"' + t + '"'; }).join(' OR ') + ')';
    if (vendor) return '(vendor:"' + vendor + '")';
    return '';
  }

  function formScope(form) {
    if (!form) return { types: [], vendor: '', hide: false };
    var types = Array.prototype.map.call(
      form.querySelectorAll('input[name="filter.p.product_type"][data-ff-scope-input]:not(:disabled)'),
      function (i) { return i.value; }
    );
    var vendorInput = form.querySelector('input[name="filter.p.vendor"][data-ff-scope-input]:not(:disabled)');
    var instock = form.querySelector('input[name="filter.v.availability"][data-ff-instock-input]');
    var productsOnly = !!form.querySelector('input[name="type"][value="product"]:not(:disabled)');
    return { types: types, vendor: vendorInput ? vendorInput.value : '', hide: !!(instock && !instock.disabled), products: productsOnly };
  }

  /* After a scope change: refresh an open dropdown, or forget the cached term so the next focus re-fetches. */
  function refreshPredictive(form) {
    var ps = form && form.closest('predictive-search');
    if (!ps || typeof ps.getQuery !== 'function' || !ps.getQuery().length) return;
    if (ps.hasAttribute('open')) {
      ps.getSearchResults(ps.getQuery());
    } else {
      ps.searchTerm = '';
      ps.removeAttribute('results');
    }
  }

  /* Replace the hidden scope inputs of a form with the given game's (null = no game). */
  function setFormGame(form, game) {
    if (!form) return;
    Array.prototype.forEach.call(form.querySelectorAll('[data-ff-scope-input]'), function (i) { i.remove(); });
    var toggle = form.querySelector('[data-ff-scope-toggle]');
    var wrap = toggle ? toggle.closest('.ff-scope__toggle') : null;
    var labels = form.querySelectorAll('[data-ff-scope-label]');
    if (!game) { if (wrap) wrap.hidden = true; return; }
    var anchor = form.querySelector('input[name="options[prefix]"]') || form.querySelector('input[name="q"]');
    function mk(name, value) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = value; i.setAttribute('data-ff-scope-input', game.key);
      anchor.insertAdjacentElement('afterend', i);
    }
    if (game.types.length) game.types.forEach(function (t) { mk('filter.p.product_type', t); });
    else if (game.vendor) mk('filter.p.vendor', game.vendor);
    Array.prototype.forEach.call(labels, function (l) { l.textContent = game.label; });
    if (wrap) { wrap.hidden = false; toggle.checked = true; }
  }

  /* 1. toggles */
  function wireForm(form) {
    if (!form || form.dataset.ffWired) return;
    form.dataset.ffWired = '1';
    var scopeToggle = form.querySelector('[data-ff-scope-toggle]');
    var instockToggle = form.querySelector('[data-ff-instock-toggle]');
    var instockInput = form.querySelector('[data-ff-instock-input]');
    /* <predictive-search> cancels every key-up that bubbles through it, and checkboxes toggle on the Space key-up.
       Only Space is stopped: Escape must still reach the modal so it closes. */
    [scopeToggle, instockToggle].forEach(function (t) {
      if (t) t.addEventListener('keyup', function (e) { if (e.key === ' ' || e.code === 'Space' || e.keyCode === 32) e.stopPropagation(); });
    });
    if (scopeToggle) {
      scopeToggle.addEventListener('change', function () {
        Array.prototype.forEach.call(form.querySelectorAll('[data-ff-scope-input]'), function (i) { i.disabled = !scopeToggle.checked; });
        refreshPredictive(form);
      });
    }
    if (instockToggle && instockInput) {
      var on;
      if (form.hasAttribute('data-ff-keep-state')) {
        /* results page: the URL is the truth once a search ran; before that, the shopper's last choice */
        var sp = new URLSearchParams(location.search);
        on = sp.has('q') ? urlInstock(sp) : readInstockPref();
      } else {
        on = readInstockPref();
      }
      instockToggle.checked = on;
      instockInput.disabled = !on;
      instockToggle.addEventListener('change', function () {
        instockInput.disabled = !instockToggle.checked;
        writeInstockPref(instockToggle.checked);
        refreshPredictive(form);
      });
    }
  }
  Array.prototype.forEach.call(document.querySelectorAll('form[role="search"]'), wireForm);

  /* 1b. remember the last game; on a page that belongs to no game, offer it in the header search, switched off */
  var pageGameInput = document.querySelector('form[role="search"] [data-ff-scope-input]');
  var pageGame = pageGameInput ? gameByKey(pageGameInput.getAttribute('data-ff-scope-input')) : null;
  if (pageGame) {
    writeGamePref(pageGame.key);
  } else {
    var remembered = gameByKey(readGamePref());
    if (remembered) {
      Array.prototype.forEach.call(document.querySelectorAll('form[role="search"]'), function (form) {
        /* not the results form (the URL is its truth) and not the Advanced Search form (its pills handle this) */
        if (form.closest('main-search') || form.closest('[data-ff-adv]') || form.querySelector('[data-ff-scope-input]')) return;
        setFormGame(form, remembered);
        var t = form.querySelector('[data-ff-scope-toggle]');
        if (t) t.checked = false;
        Array.prototype.forEach.call(form.querySelectorAll('[data-ff-scope-input]'), function (i) { i.disabled = true; });
      });
    }
  }

  /* 2. predictive search scoping */
  if (window.customElements && window.customElements.whenDefined) {
    customElements.whenDefined('predictive-search').then(function () {
      var PS = customElements.get('predictive-search');
      if (!PS || PS.prototype.__ffPatched) return;
      PS.prototype.__ffPatched = true;
      PS.prototype.getSearchResults = function (searchTerm) {
        var self = this;
        var scope = formScope(this.input && this.input.form);
        var qualifier = qualifierFor(scope.types, scope.vendor);
        /* With a field qualifier in q Shopify stops prefix-matching the typed term ("char" no longer finds
           Charizard); an explicit trailing * restores the stock prefix behaviour (verified on the live endpoint). */
        var term = searchTerm.trim();
        var starred = qualifier && /[A-Za-z0-9À-ɏ]$/.test(term) ? term + '*' : term;
        var q = qualifier ? qualifier + ' ' + starred : searchTerm;
        var queryKey = (qualifier + '|' + (scope.hide ? '1' : '0') + (scope.products ? 'p' : 'a') + '|' + searchTerm).toLowerCase();
        this.setLiveRegionLoadingState();

        if (this.cachedResults[queryKey]) {
          this.renderSearchResults(this.cachedResults[queryKey]);
          var cachedDeferred = this.dispatchSearchUpdateEvent(searchTerm);
          if (cachedDeferred) cachedDeferred.resolve({ totalCount: this.getTotalResultCount() });
          return;
        }

        var searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);
        var url = routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search';
        if (scope.hide) url += '&resources[options][unavailable_products]=hide';
        /* the form submits type=product, so the dropdown should not promise pages or articles the results hide */
        if (scope.products) url += '&resources[type]=product,query';

        fetch(url, { signal: this.abortController.signal })
          .then(function (response) {
            if (!response.ok) {
              var error = new Error(response.status);
              self.close();
              throw error;
            }
            return response.text();
          })
          .then(function (text) {
            var resultsMarkup = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#shopify-section-predictive-search').innerHTML;
            if (qualifier) {
              /* the section echoes the raw q in "Search for ..." / "No results for ..."; hide the qualifier and the * */
              resultsMarkup = resultsMarkup.split(qualifier + ' ').join('').split(htmlEscape(qualifier) + ' ').join('');
              if (starred !== term) {
                resultsMarkup = resultsMarkup.split(starred).join(term).split(htmlEscape(starred)).join(htmlEscape(term));
              }
            }
            self.allPredictiveSearchInstances.forEach(function (instance) { instance.cachedResults[queryKey] = resultsMarkup; });
            self.renderSearchResults(resultsMarkup);
            if (searchDeferred) searchDeferred.resolve({ totalCount: self.getTotalResultCount() });
          })
          .catch(function (error) {
            if (error && error.code === 20) { if (searchDeferred) searchDeferred.reject(error); return; }
            if (searchDeferred) searchDeferred.reject(error);
            self.close();
            throw error;
          });
      };
    });
  }

  /* 3. results page: facet forms + old ?game= links */
  var onSearchPage = /\/search\/?$/.test(location.pathname);
  if (onSearchPage) {
    /* facets.js rebuilds the URL from the facet forms alone, so give them the products-only flag too */
    var facetForms = [];
    var desktopFacets = document.getElementById('FacetFiltersForm') || document.getElementById('FacetSortDrawerForm');
    if (desktopFacets) facetForms.push(desktopFacets);
    var mobileFacets = document.getElementById('FacetFiltersFormMobile');
    if (mobileFacets) facetForms.push(mobileFacets);
    facetForms.forEach(function (f) {
      if (f.querySelector('input[name="type"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'type'; i.value = 'product';
      f.appendChild(i);
    });

    var params = new URLSearchParams(location.search);
    var linkedGame = gameByKey(params.get('game'));
    if (linkedGame && !params.has('filter.p.product_type') && !params.has('filter.p.vendor')) {
      if (params.get('q')) {
        params.delete('game');
        linkedGame.types.forEach(function (t) { params.append('filter.p.product_type', t); });
        if (!linkedGame.types.length && linkedGame.vendor) params.append('filter.p.vendor', linkedGame.vendor);
        if (!params.has('type')) params.set('type', 'product');
        if (!params.has('options[prefix]')) params.set('options[prefix]', 'last');
        location.replace(location.pathname + '?' + params.toString());
      } else {
        /* no term yet: preselect the game in the page's search box */
        var mainFormEarly = document.querySelector('main-search form[role="search"]');
        if (mainFormEarly) setFormGame(mainFormEarly, linkedGame);
      }
    }
  }

  /* 4a. Set picker (snippets/ff-set-picker.liquid + assets/ff-sets-<game>.json, one small file per game) */
  var setsCache = {};
  function loadGame(key, url) {
    if (!setsCache[key]) {
      setsCache[key] = (url ? fetch(url, { credentials: 'same-origin' }) : Promise.reject(new Error('no url')))
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return setsCache[key];
  }
  function tagOf(s) { return s.t || s.l; }
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var NO_GAME_HINT = 'Pick a game to choose a set';

  function wireSetPicker(el, opts) {
    if (!el || el.dataset.ffWired) return null;
    el.dataset.ffWired = '1';
    opts = opts || {};
    var input = el.querySelector('[data-ff-setpick-input]');
    var list = el.querySelector('[data-ff-setpick-list]');
    var clear = el.querySelector('[data-ff-setpick-clear]');
    var hidden = el.querySelector('[data-ff-setpick-value]');
    var status = el.querySelector('[data-ff-setpick-status]');
    var form = input.form || el.closest('form');
    var placeholder = input.getAttribute('data-ff-placeholder') || 'Any set';
    var urls = {};
    try { urls = JSON.parse(el.dataset.ffSetsUrls || '{}'); } catch (e) { urls = {}; }
    var gameData = null; /* the loaded { mode, sets } of state.gameKey */
    var loadingKey = null; /* game whose file is being fetched right now */
    var state = {
      gameKey: el.dataset.ffGame || '',
      mode: 'tag',
      all: [],
      current: null,      /* what the field resolves to right now */
      applied: null,      /* the set the page is filtered by (server value / URL) */
      pendingTags: hidden.disabled ? [] : [hidden.value],
      pendingQuery: null
    };

    /* <predictive-search> hijacks arrows, Enter and every key-up on its descendants; keep this field to itself.
       Enter: on the results page it applies the set (never re-submits the words); elsewhere it resolves, then the form submits. */
    input.addEventListener('keyup', function (e) { e.stopPropagation(); });
    input.addEventListener('keydown', function (e) {
      e.stopPropagation();
      if (e.key !== 'Enter') return;
      if (opts.applyOnChange) { e.preventDefault(); commit(false); } else { commit(true); }
    });
    if (clear) clear.addEventListener('keyup', function (e) { if (e.key === ' ' || e.code === 'Space' || e.keyCode === 32) e.stopPropagation(); });

    function byTag(tag) {
      if (!tag) return null;
      for (var i = 0; i < state.all.length; i++) if (tagOf(state.all[i]) === tag) return state.all[i];
      return null;
    }
    function find(text) {
      var t = (text || '').trim().toLowerCase();
      if (!t) return null;
      for (var i = 0; i < state.all.length; i++) {
        var s = state.all[i];
        if (s.l.toLowerCase() === t || tagOf(s).toLowerCase() === t) return s;
      }
      var starts = state.all.filter(function (s) { return s.l.toLowerCase().indexOf(t) === 0; });
      return starts.length === 1 ? starts[0] : null;
    }
    /* query-mode games (no set tag): the set travels as a quoted phrase at the end of the words, e.g.
       elsa "The First Chapter" (bare words are OR-matched by Shopify; a quoted phrase is enforced) */
    function matchQuery(q) {
      var t = (q || '').toLowerCase().replace(/\s+/g, ' ').trim();
      var best = null;
      for (var i = 0; i < state.all.length; i++) {
        var l = state.all[i].l.toLowerCase();
        var quoted = '"' + l + '"';
        var hit = t === quoted || t === l || t.slice(-(quoted.length + 1)) === ' ' + quoted || t.slice(-(l.length + 1)) === ' ' + l;
        if (hit && (!best || l.length > best.l.length)) best = state.all[i];
      }
      return best;
    }
    function flag(bad, text) {
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (status) status.textContent = bad ? 'No set called "' + text + '". Choose one from the list.' : '';
    }
    function apply(s, silent) {
      state.current = s || null;
      if (s && state.mode === 'tag') { hidden.value = tagOf(s); hidden.disabled = false; }
      else { hidden.value = ''; hidden.disabled = true; }
      if (clear) clear.hidden = !input.value;
      if (silent) return;
      var prev = state.applied;
      state.applied = state.current;
      el.dispatchEvent(new CustomEvent('ff:set', { bubbles: true, detail: { set: state.current, prev: prev, mode: state.mode } }));
    }
    function showNoGame() {
      el.hidden = false;
      input.disabled = true;
      input.value = '';
      input.placeholder = NO_GAME_HINT;
      flag(false);
      apply(null, true);
    }
    function fillList() {
      var instockInput = form ? form.querySelector('[data-ff-instock-input]') : null;
      var onlyStock = !!(instockInput && !instockInput.disabled);
      var listed = state.all.filter(function (s) { return !onlyStock || (s.n || 0) > 0; });
      if (!listed.length) listed = state.all;
      list.innerHTML = '';
      var frag = document.createDocumentFragment();
      listed.forEach(function (s) { var o = document.createElement('option'); o.value = s.l; frag.appendChild(o); });
      list.appendChild(frag);
    }
    /* resolvePage: show the set the page is filtered by (pending server/URL values); otherwise keep what is typed */
    function render(resolvePage) {
      var game = state.gameKey ? gameByKey(state.gameKey) : null;
      var g = gameData;
      if (!game) { showNoGame(); return; }
      if (!g || !g.sets || !g.sets.length) { el.hidden = true; apply(null, true); return; }
      state.mode = g.mode || 'tag';
      state.all = g.sets;
      fillList();
      el.hidden = false;
      input.disabled = false;
      input.placeholder = placeholder;
      if (!resolvePage) { apply(find(input.value), true); return; }
      var pre = null;
      if (state.mode === 'query') {
        if (state.pendingQuery !== null) pre = matchQuery(state.pendingQuery);
      } else {
        for (var i = 0; i < state.pendingTags.length && !pre; i++) pre = byTag(state.pendingTags[i]);
      }
      state.pendingTags = [];
      state.pendingQuery = null;
      state.applied = pre;
      input.value = pre ? pre.l : '';
      flag(false);
      apply(pre, true);
    }
    function setGame(key) {
      key = key || '';
      if (key === state.gameKey && gameData) return;
      if (key !== state.gameKey) {
        input.value = '';
        gameData = null;
        state.current = null; state.applied = null; state.pendingTags = []; state.pendingQuery = null;
        flag(false);
      }
      state.gameKey = key;
      el.dataset.ffGame = key;
      if (!key) { showNoGame(); return; }
      if (gameData) { render(true); return; }
      if (loadingKey === key) return; /* already on its way: one render, with whatever is pending by then */
      loadingKey = key;
      loadGame(key, urls[key]).then(function (g) {
        if (loadingKey === key) loadingKey = null;
        if (state.gameKey !== key) return; /* the shopper moved on to another game meanwhile */
        gameData = g;
        render(true);
      });
    }
    function commit(silent) {
      var text = input.value.trim();
      var s = find(text);
      if (!s && text) {
        /* not a set we know: say so and keep what the page is filtered by */
        flag(true, text);
        input.value = state.applied ? state.applied.l : '';
        apply(state.applied, true);
        return;
      }
      flag(false);
      if (s) input.value = s.l;
      apply(s, !!silent);
    }
    input.addEventListener('input', function () { flag(false); apply(find(input.value), true); });
    input.addEventListener('change', function () { commit(false); });
    if (clear) clear.addEventListener('click', function () { input.value = ''; flag(false); apply(null, false); input.focus(); });
    if (form) {
      var inst = form.querySelector('[data-ff-instock-toggle]');
      if (inst) inst.addEventListener('change', function () { if (gameData && state.gameKey) render(false); });
    }
    setGame(state.gameKey);
    return {
      el: el,
      setGame: setGame,
      get: function () { return state.current; },
      applied: function () { return state.applied; },
      mode: function () { return state.mode; },
      /* URL truth for the results page: every active tag value (the first that is a set wins) and the words */
      syncFromUrl: function (tags, q) {
        state.pendingTags = tags || [];
        state.pendingQuery = q == null ? null : String(q);
        if (gameData && state.gameKey) render(true);
      }
    };
  }

  /* 4b. Filter groups (snippets/ff-filter-groups.liquid): one <select> per group from the game's file.
     One choice per group; the choices become filter.p.tag values (they only narrow together once the store's
     Product tag filter is set to "Match all"). */
  function wireFilterGroups(el, opts) {
    if (!el || el.dataset.ffWired) return null;
    el.dataset.ffWired = '1';
    opts = opts || {};
    var form = el.closest('form');
    var picker = form ? form.querySelector('[data-ff-setpick]') : null;
    var urls = {};
    try { urls = JSON.parse((picker && picker.dataset.ffSetsUrls) || '{}'); } catch (e) { urls = {}; }
    var state = { gameKey: (picker && picker.dataset.ffGame) || '', selected: {}, data: null }; /* selected: group label -> tag (or condition name) */
    /* The condition lives in a variant option whose NAME differs by who created the product: BinderPOS singles keep it
       in the default option ("Title"), Atlas singles in one called "Condition". Shopify's filter parameter follows that
       name, so send both spellings unless the page's own facet tells us which one is live. */
    var OPTION_PARAMS = ['filter.v.option.condition', 'filter.v.option.title'];
    var COND = 'Condition';
    function liveOptionParam() {
      var el = document.querySelector('.facets input[name^="filter.v.option."], form[id^="Facet"] input[name^="filter.v.option."]');
      return el ? el.name : null;
    }
    function optionParams() {
      var live = liveOptionParam();
      return live ? [live] : OPTION_PARAMS;
    }

    function urlTags() { return new URLSearchParams(location.search).getAll('filter.p.tag'); }
    /* every option value that belongs to a condition: the live facet's values when the page has them, else the file's */
    function condValues(c) {
      var live = liveOptionParam();
      if (live) {
        /* Dawn renders the facets twice (desktop and the mobile drawer), so the same value appears more than once */
        var seen = {};
        var fromLive = Array.prototype.map.call(document.querySelectorAll('input[name="' + live + '"]'), function (i) { return i.value; })
          .filter(function (v) {
            if (v !== c && v.indexOf(c + ' ') !== 0) return false;
            if (seen[v]) return false;
            seen[v] = 1;
            return true;
          });
        if (fromLive.length) return fromLive;
      }
      return (state.data && state.data.cond && state.data.cond[c]) || [c];
    }
    function syncHidden() {
      /* Advanced page: the choices ride along as hidden inputs inside the form */
      if (opts.applyOnChange || !form) return;
      Array.prototype.forEach.call(el.querySelectorAll('[data-ff-group-input]'), function (i) { i.remove(); });
      Object.keys(state.selected).forEach(function (gl) {
        var t = state.selected[gl];
        if (!t) return;
        var names = gl === COND ? optionParams() : ['filter.p.tag'];
        var values = gl === COND ? condValues(t) : [t];
        names.forEach(function (name) {
          values.forEach(function (v) {
            var i = document.createElement('input');
            i.type = 'hidden'; i.name = name; i.value = v; i.setAttribute('data-ff-group-input', gl);
            el.appendChild(i);
          });
        });
      });
    }
    function onChange(grp, sel) {
      state.selected[grp.g] = sel.value;
      sel.classList.toggle('ff-groups__select--active', !!sel.value);
      if (!opts.applyOnChange) { syncHidden(); return; }
      /* results page: swap this group's value(s) in the URL, keep everything else, reload */
      var p = new URLSearchParams(location.search);
      if (!p.has('q')) return;
      if (grp.g === COND) {
        OPTION_PARAMS.forEach(function (n) { p.delete(n); });
        if (sel.value) {
          var vals = condValues(sel.value);
          optionParams().forEach(function (n) { vals.forEach(function (v) { p.append(n, v); }); });
        }
      } else {
        var groupTags = grp.v.map(tagOf);
        var keep = p.getAll('filter.p.tag').filter(function (t) { return groupTags.indexOf(t) === -1; });
        p.delete('filter.p.tag');
        keep.forEach(function (t) { p.append('filter.p.tag', t); });
        if (sel.value) p.append('filter.p.tag', sel.value);
      }
      p.delete('page');
      location.href = location.pathname + '?' + p.toString();
    }
    function build(g) {
      state.data = g || null;
      Array.prototype.forEach.call(el.querySelectorAll('.ff-groups__item'), function (n) { n.remove(); });
      var groups = (g && g.groups) ? g.groups.slice() : [];
      if (g && g.cond) {
        /* the Condition dropdown: five conditions, each standing for every "<condition> <finish>" value */
        groups.push({ g: COND, v: Object.keys(g.cond).map(function (c) { return { l: c, n: 1 }; }) });
      }
      if (!groups.length) { el.hidden = true; syncHidden(); return; }
      var instockInput = form ? form.querySelector('[data-ff-instock-input]') : null;
      var onlyStock = !!(instockInput && !instockInput.disabled);
      var active = opts.applyOnChange ? urlTags() : [];
      var activeOptions = [];
      if (opts.applyOnChange) {
        var sp = new URLSearchParams(location.search);
        OPTION_PARAMS.forEach(function (n) { activeOptions = activeOptions.concat(sp.getAll(n)); });
      }
      groups.forEach(function (grp) {
        var values = grp.v.filter(function (v) { return !onlyStock || (v.n || 0) > 0; });
        if (!values.length) return;
        var wrap = document.createElement('label');
        wrap.className = 'ff-groups__item';
        var span = document.createElement('span');
        span.className = 'ff-groups__label';
        span.textContent = grp.g;
        var sel = document.createElement('select');
        sel.className = 'ff-groups__select';
        sel.setAttribute('data-ff-group', grp.g);
        var any = document.createElement('option');
        any.value = '';
        any.textContent = 'Any';
        sel.appendChild(any);
        values.forEach(function (v) {
          var o = document.createElement('option');
          o.value = tagOf(v);
          o.textContent = v.l;
          sel.appendChild(o);
        });
        var current;
        if (grp.g === COND) {
          current = Object.keys(g.cond).filter(function (c) {
            return activeOptions.some(function (v) { return v === c || v.indexOf(c + ' ') === 0; });
          })[0] || state.selected[grp.g] || '';
        } else {
          current = grp.v.map(tagOf).filter(function (t) { return active.indexOf(t) !== -1; })[0] || state.selected[grp.g] || '';
        }
        sel.value = current;
        if (sel.value !== current) sel.value = '';
        state.selected[grp.g] = sel.value;
        sel.classList.toggle('ff-groups__select--active', !!sel.value);
        /* <predictive-search> would swallow the arrow keys and every key-up */
        ['keydown', 'keyup'].forEach(function (ev) { sel.addEventListener(ev, function (e) { e.stopPropagation(); }); });
        sel.addEventListener('change', function () { onChange(grp, sel); });
        wrap.appendChild(span);
        wrap.appendChild(sel);
        el.appendChild(wrap);
      });
      el.hidden = !el.querySelector('.ff-groups__item');
      syncHidden();
    }
    function setGame(key) {
      key = key || '';
      if (key !== state.gameKey) state.selected = {};
      state.gameKey = key;
      if (!key) { build(null); return; }
      loadGame(key, urls[key]).then(function (g) { if (state.gameKey !== key) return; build(g); });
    }
    if (form) {
      var inst = form.querySelector('[data-ff-instock-toggle]');
      if (inst) inst.addEventListener('change', function () { if (state.gameKey) setGame(state.gameKey); });
    }
    setGame(state.gameKey);
    return { el: el, setGame: setGame };
  }

  /* 4. Advanced Search page */
  var adv = document.querySelector('[data-ff-adv]');
  if (adv) {
    var advForm = adv.querySelector('form[role="search"]');
    var advLinks = adv.querySelector('[data-ff-adv-links]');
    var advPicker = wireSetPicker(adv.querySelector('[data-ff-setpick]'), {});
    var advGroups = wireFilterGroups(adv.querySelector('[data-ff-groups]'), {});
    var pills = Array.prototype.slice.call(adv.querySelectorAll('[data-ff-adv-game]'));
    var selectGame = function (raw) {
      var game = gameByKey(raw);
      /* a game with no pill (vendor-only scope) cannot be shown honestly: fall back to All games */
      if (game && !pills.some(function (p) { return p.getAttribute('data-ff-adv-game') === game.key; })) game = null;
      pills.forEach(function (p) {
        var on = (p.getAttribute('data-ff-adv-game') || '') === (game ? game.key : '');
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setFormGame(advForm, game);
      if (advPicker) advPicker.setGame(game ? game.key : '');
      if (advGroups) advGroups.setGame(game ? game.key : '');
      if (advLinks) {
        advLinks.hidden = !game;
        if (game) {
          [['singles', game.singles], ['sealed', game.sealed], ['preorders', game.preorders], ['restocks', game.restocks]].forEach(function (pair) {
            var a = advLinks.querySelector('[data-ff-link="' + pair[0] + '"]');
            if (!a) return;
            a.hidden = !pair[1];
            a.href = pair[1] ? '/collections/' + pair[1] : '#';
          });
          Array.prototype.forEach.call(advLinks.querySelectorAll('[data-ff-scope-label]'), function (l) { l.textContent = game.label; });
        }
      }
      refreshPredictive(advForm);
    };
    pills.forEach(function (p) { p.addEventListener('click', function () { selectGame(p.getAttribute('data-ff-adv-game')); }); });
    var advParams = new URLSearchParams(location.search);
    selectGame(advParams.get('game') || readGamePref() || '');
    pills.forEach(function (p) { p.addEventListener('click', function () { writeGamePref(p.getAttribute('data-ff-adv-game')); }); });
    var presetQ = advParams.get('q');
    if (presetQ && advForm) {
      var qInput = advForm.querySelector('input[name="q"]');
      if (qInput && !qInput.value) qInput.value = presetQ;
    }
    /* a set with no words: the set's own collection when it has one, else the set name searched inside the tag */
    if (advForm && advPicker) {
      advForm.addEventListener('submit', function (e) {
        var q = advForm.querySelector('input[name="q"]');
        var s = advPicker.get();
        if (!q || !s) return;
        var term = q.value.trim();
        if (advPicker.mode() === 'query') {
          var phrase = '"' + s.l + '"';
          if (term.toLowerCase().indexOf(s.l.toLowerCase()) === -1) q.value = term ? term + ' ' + phrase : phrase;
        } else if (!term) {
          if (s.h) { e.preventDefault(); location.href = '/collections/' + s.h; return; }
          q.value = s.l;
        }
        if (e.defaultPrevented) {
          /* predictive-search cancelled the submit while the words were still empty: go ourselves */
          location.href = advForm.getAttribute('action') + '?' + new URLSearchParams(new FormData(advForm)).toString();
        }
      });
    }
  }

  /* 5. keep the results page honest after facet updates (facets.js only re-renders the grid and the facets) */
  function syncTabs(searchParams) {
    var p = new URLSearchParams(searchParams);
    var selected = p.getAll('filter.p.product_type');
    var g = null;
    var active = '';
    if (selected.length) {
      for (var i = 0; i < games.length; i++) {
        var all = selected.every(function (t) { return games[i].types.indexOf(t) !== -1; });
        if (all) { g = games[i]; break; }
      }
      active = g ? g.key : 'mixed';
    }
    var avail = urlInstock(p);
    var nav = document.querySelector('[data-ff-tabs]');
    if (nav) {
      Array.prototype.forEach.call(nav.querySelectorAll('[data-ff-tab]'), function (a) {
        var on = a.getAttribute('data-ff-tab') === active;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        var href = a.getAttribute('href') || '';
        if (href.indexOf('?') === -1) return;
        var u = new URL(href, location.origin);
        u.searchParams.delete('filter.v.availability');
        if (avail) u.searchParams.set('filter.v.availability', '1');
        a.setAttribute('href', u.pathname + u.search);
      });
    }
    var title = document.querySelector('[data-ff-title-game]');
    if (title) title.textContent = g ? ' · ' + g.label : '';
    var mainForm = document.querySelector('main-search form[role="search"]');
    if (mainForm) {
      setFormGame(mainForm, g);
      var inst = mainForm.querySelector('[data-ff-instock-input]');
      var tog = mainForm.querySelector('[data-ff-instock-toggle]');
      if (inst) inst.disabled = !avail;
      if (tog) tog.checked = avail;
      if (resultsPicker) {
        resultsPicker.setGame(g ? g.key : '');
        resultsPicker.syncFromUrl(p.getAll('filter.p.tag'), p.get('q') || '');
      }
      if (resultsGroups) resultsGroups.setGame(g ? g.key : '');
    }
  }
  if (window.customElements && window.customElements.whenDefined) {
    customElements.whenDefined('facet-filters-form').then(function () {
      var F = customElements.get('facet-filters-form');
      if (!F || !F.renderPage || F.__ffPatched) return;
      F.__ffPatched = true;
      var orig = F.renderPage;
      F.renderPage = function (searchParams, event, updateURLHash) {
        if (typeof updateURLHash === 'undefined') updateURLHash = true;
        orig.call(F, searchParams, event, updateURLHash);
        syncTabs(searchParams);
      };
    });
  }
  /* results page: the Set field applies straight away, like a facet, by reloading with the set changed */
  var resultsPicker = wireSetPicker(document.querySelector('main-search [data-ff-setpick]'), { applyOnChange: true });
  var resultsGroups = wireFilterGroups(document.querySelector('main-search [data-ff-groups]'), { applyOnChange: true });
  if (resultsPicker) {
    var resultsForm = resultsPicker.el.closest('form');
    var resultsSetInput = resultsPicker.el.querySelector('[data-ff-setpick-input]');
    /* Enter inside the Set field must never re-submit the words form */
    if (resultsForm) resultsForm.addEventListener('submit', function (e) { if (document.activeElement === resultsSetInput) e.preventDefault(); });
    var earlyParams = new URLSearchParams(location.search);
    if (onSearchPage && !earlyParams.has('q')) {
      /* /search?game=mtg with no words yet: offer that game's sets right away */
      var earlyGame = gameByKey(earlyParams.get('game'));
      if (earlyGame) resultsPicker.setGame(earlyGame.key);
    }
    resultsPicker.el.addEventListener('ff:set', function (e) {
      var p = new URLSearchParams(location.search);
      if (!p.has('q')) return;
      var s = e.detail.set;
      var prev = e.detail.prev;
      if ((s ? s.l : '') === (prev ? prev.l : '')) return; /* nothing changed */
      p.delete('page');
      if (e.detail.mode === 'query') {
        var q = p.get('q') || '';
        if (prev) q = q.replace(new RegExp('\\s*"?' + escapeRe(prev.l) + '"?\\s*$', 'i'), '').trim();
        if (s && q.toLowerCase().indexOf(s.l.toLowerCase()) === -1) q = (q + ' "' + s.l + '"').trim();
        if (!q) { resultsPicker.syncFromUrl([], p.get('q') || ''); return; } /* the words were only the set name: keep it */
        p.set('q', q);
      } else {
        var keep = p.getAll('filter.p.tag').filter(function (t) { return !(prev && t === tagOf(prev)); });
        p.delete('filter.p.tag');
        keep.forEach(function (t) { p.append('filter.p.tag', t); });
        if (s) p.append('filter.p.tag', tagOf(s));
      }
      location.href = location.pathname + '?' + p.toString();
    });
  }
  /* on a performed search the URL is the truth from the first paint too (zero-result pages render no filters) */
  if (onSearchPage && new URLSearchParams(location.search).has('q')) syncTabs(location.search.slice(1));


  /* 8. APPLY IN PLACE - no navigation, no page swap.
     ------------------------------------------------------------------
     Jeremy, 2026-10-09: "I would like the filters to be applied, but not to
     change the page, or the way you apply filters on the next page... I think
     that looks unprofessional. I would even be fine with what's working if
     this URL swapping and navigation wasn't happening."

     So the shopper now never leaves the collection. Apply fetches the results
     with Shopify's Section Rendering API and swaps the grid, the count and the
     pager in place; the filter bar is untouched because it lives in the same
     section and is deliberately NOT part of what gets replaced.

     Two renderers, picked by what the selection needs - the SHOPPER sees no
     difference because both paint into the same #product-grid:
       <=1 per axis  -> the collection's own section on a tag path. Exact tag
                        matching, no 1,000 cap, real "N of M products" count.
       >=2 anywhere  -> the search section with the OR query, because the tag
                        path has no OR. Capped at 1,000 by Shopify.

     The URL stays a COLLECTION url and carries the selection in ?ffgf= (the
     same shape Fast Simon uses on 401's store), so a filtered view is
     shareable, the back button works, and a cold load reproduces it. */
  function ffInPlace(ctx) {
    var sectionEl = document.querySelector('[id^="shopify-section-"][id$="__product-grid"]')
      || (document.querySelector('#product-grid') || {}).closest
        ? (document.querySelector('#product-grid') || { closest: function () { return null; } }).closest('[id^="shopify-section-"]')
        : null;
    if (!sectionEl) return null;
    var sectionId = sectionEl.id.replace('shopify-section-', '');

    function grid() { return sectionEl.querySelector('#product-grid'); }
    function countEl() { return sectionEl.querySelector('#ProductCount, [data-product-count]'); }
    function pager() { return sectionEl.querySelector('.pagination-wrapper'); }

    function busy(on) {
      var g = grid();
      if (!g) return;
      g.style.opacity = on ? '0.35' : '';
      g.style.pointerEvents = on ? 'none' : '';
      g.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    /* ---- the two section urls ------------------------------------------ */
    function collectionSectionUrl(handles, page) {
      var u = ctx.base + (handles.length ? '/' + handles.join('+') : '');
      var p = new URLSearchParams();
      p.set('section_id', sectionId);
      if (page && page > 1) p.set('page', String(page));
      var sort = new URLSearchParams(ctx.qs.replace(/^\?/, '')).get('sort_by');
      if (sort) p.set('sort_by', sort);
      return u + '?' + p.toString();
    }
    function searchSectionUrl(built, page) {
      var p = new URLSearchParams();
      p.set('type', 'product');
      p.set('q', built.q);
      built.filterTags.forEach(function (t) { p.append('filter.p.tag', t); });
      p.append('filter.v.availability', '1');
      p.set('section_id', 'main-search');
      if (page && page > 1) p.set('page', String(page));
      return '/search?' + p.toString();
    }

    /* ---- swap only the three pieces the results own -------------------- */
    function paint(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('#product-grid');
      var g = grid();
      if (newGrid && g) g.innerHTML = newGrid.innerHTML;

      var newCount = doc.querySelector('#ProductCount, [data-product-count]');
      var c = countEl();
      if (newCount && c) {
        /* FF p-23: markup, as facets.js copies it - the phone count carries its tag in a phone-only span */
        c.innerHTML = newCount.innerHTML;
        if (newCount.getAttribute('data-product-count')) c.setAttribute('data-product-count', newCount.getAttribute('data-product-count'));
        if (newCount.getAttribute('data-total-count')) c.setAttribute('data-total-count', newCount.getAttribute('data-total-count'));
      }
      /* FF p-23: the desktop count and the phone drawer's count print the same line and were never
         refreshed here, so after an in-place Apply the desktop line kept the old page's figure (measured
         on the draft: 294 over a 242-card Bloomburrow grid). Same section response, same element. */
      ['#ProductCountDesktop', '.mobile-facets__count'].forEach(function (sel) {
        var from = doc.querySelector(sel);
        var to = sectionEl.querySelector(sel);
        if (from && to) to.innerHTML = from.innerHTML;
      });

      var newPager = doc.querySelector('.pagination-wrapper');
      var pg = pager();
      if (pg) pg.innerHTML = newPager ? newPager.innerHTML : '';
      else if (newPager && g && g.parentNode) g.parentNode.appendChild(newPager.cloneNode(true));

      /* a filtered view that lands mid-page looks broken */
      var top = sectionEl.getBoundingClientRect().top + window.scrollY - 80;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function load(url) {
      busy(true);
      return fetch(url)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (h) { paint(h); })
        .catch(function () {
          /* never strand the shopper on a dimmed grid - fall back to a real
             navigation, which is what the whole feature used to do anyway */
          window.location.href = url.replace(/([?&])section_id=[^&]*/, '$1').replace(/[?&]$/, '');
        })
        .then(function () { busy(false); });
    }

    /* ---- ?ffgf= on a collection url ------------------------------------ */
    function encode(state) {
      var parts = [];
      Object.keys(state).forEach(function (g) {
        if (state[g].length) parts.push(g + ':' + state[g].join('~'));
      });
      return parts.join('|');
    }
    function decode(raw) {
      var out = {};
      if (!raw) return out;
      raw.split('|').forEach(function (chunk) {
        var i = chunk.indexOf(':');
        if (i === -1) return;
        out[chunk.slice(0, i)] = chunk.slice(i + 1).split('~').filter(Boolean);
      });
      return out;
    }
    function pushUrl(state, handles, isMulti, replace) {
      var u;
      if (!isMulti) {
        /* a real, shareable tag-path url - exactly what the links used to be */
        u = ctx.base + (handles.length ? '/' + handles.join('+') : '') + ctx.qs;
      } else {
        var p = new URLSearchParams(ctx.qs.replace(/^\?/, ''));
        p.set('ffgf', encode(state));
        u = ctx.base + '?' + p.toString();
      }
      try {
        if (replace) history.replaceState({ ffgf: encode(state) }, '', u);
        else history.pushState({ ffgf: encode(state) }, '', u);
      } catch (e) { /* ignore */ }
    }

    /* ---- pagination inside the swapped markup -------------------------- */
    var currentUrlFor = null;
    sectionEl.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('.pagination-wrapper a[href]');
      if (!a || !currentUrlFor) return;
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0) return;
      var page = new URLSearchParams(a.getAttribute('href').split('?')[1] || '').get('page');
      if (!page) return;
      ev.preventDefault();
      load(currentUrlFor(Number(page)));
    });

    return {
      /* called by the bar instead of location.href = ... */
      apply: function (state, handles, isMulti, built, replace) {
        currentUrlFor = isMulti
          ? function (page) { return searchSectionUrl(built, page); }
          : function (page) { return collectionSectionUrl(handles, page); };
        pushUrl(state, handles, isMulti, replace);
        return load(currentUrlFor(1));
      },
      decode: decode,
      /* a cold load of ?ffgf=... must reproduce the filtered view */
      pending: decode(new URLSearchParams(location.search).get('ffgf')),
      busy: busy,
    };
  }
  /* 6. MULTI-SELECT on the collection filter bar.
     ------------------------------------------------------------------
     Jeremy, 2026-10-08: "two sets, and a colour from MTG, 2 colours and 4 sets.
     2 Energy types and a set Pokemon."

     Why this is not just "allow two checkboxes": the bar navigates on Shopify
     TAG PATHS (/collections/<h>/<a>+<b>), and that grammar is AND-only - there
     is no OR in it at all, so two sets means a card carrying BOTH, i.e. zero.
     Shopify's own tag facet cannot help either: it has ONE Match-all/any
     setting for every tag in the store, so turning two sets into a union would
     turn "sets AND a colour" into a union too.

     The one mechanism that does both is the search query string, measured on
     this store 2026-10-08:
         (tag:"Aetherdrift" OR tag:"Foundations")            414  = 193 + 222
         ... tag:"Red"                                        96  (narrows: AND)
         ... &filter.p.tag=Mythic                            410  (exact, ANDs in)
     So: OR inside one axis, AND across axes, and single-value axes ride as
     filter.p.tag because THAT is an exact match while tag:"X" inside q is only
     a PHRASE match.

     That phrase match is why EXCLUSIONS exist below. Measured: Mythic +
     tag:"Aetherdrift" = 193, of which tag:"Aetherdrift Commander" = 191. Pick
     a set without excluding its children and the shopper gets 99% the wrong
     product. Exclusions are not a refinement, they are the feature working.

     Routing, and why single-select is untouched:
       every axis <= 1 value  -> the tag path, exactly as today (exact tags,
                                 collection pagination, no 1,000 cap)
       any axis >= 2 values   -> /search with the built query
     So nothing regresses for the common case; the new path only runs when the
     shopper does the thing that used to be impossible. */
  function ffMulti() {
    var root = document.querySelector('.ffgf[data-ffgf-game]');
    if (!root || root.dataset.ffgfMulti) return;
    root.dataset.ffgfMulti = '1';

    var gameKey = root.dataset.ffgfGame || '';
    var gameDef = gameByKey(gameKey);
    var handle = root.dataset.ffgfHandle || '';
    var base = root.dataset.ffgfBase || '';
    var qs = root.dataset.ffgfQs || '';
    var dds = Array.prototype.slice.call(root.querySelectorAll('.ffgf__dd[data-ffgf-group]'));
    if (!dds.length) return;

    /* ---- vocabulary: every tag this game shows, across every axis. Needed in
       full because containment crosses axes - the MTG rarity "Special" is
       inside the set "Bloomburrow Special Guests". */
    var vocabulary = [];
    dds.forEach(function (dd) {
      Array.prototype.forEach.call(dd.querySelectorAll('.ffgf__opt[data-ffgf-tag]'), function (a) {
        var t = a.getAttribute('data-ffgf-tag');
        if (t && vocabulary.indexOf(t) === -1) vocabulary.push(t);
      });
    });

    /* Approximates Shopify's phrase match: token-subsequence, case and
       punctuation insensitive. "Theros" is inside "Theros Beyond Death" but not
       inside "Therosian". */
    function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function phraseContains(haystack, needle) {
      var h = ' ' + norm(haystack) + ' ';
      var n = ' ' + norm(needle) + ' ';
      return h !== n && h.indexOf(n) !== -1;
    }

    /* the handleized tag, taken from the href Shopify already built rather than
       reimplementing `handleize` - punctuation rules we would get subtly wrong */
    function handleOf(a) {
      var href = a.getAttribute('href') || '';
      var path = href.split('?')[0].replace(/\/+$/, '');
      var last = path.split('/').pop() || '';
      var parts = last.split('+');
      return parts[parts.length - 1] || '';
    }

    /* ---- state: group label -> array of selected tags ------------------- */
    /* Seeded from the URL PATH, not from the rendered active state. Measured on
       the draft 2026-10-08: on /collections/mtg-in-stock-only/aetherdrift the
       snippet renders no is-active option and no chip, because
       collection.current_tags comes back empty there - a pre-existing quirk this
       code must not depend on. Without URL seeding the bar would forget the
       filter already applied, so adding a SECOND set would silently replace the
       first instead of widening to either. data-ffgf-on is kept as a second
       source for whenever current_tags does populate. */
    var pathTags = (function () {
      var p = location.pathname.replace(/\/+$/, '').split('/');
      var i = p.indexOf('collections');
      if (i === -1 || !p[i + 2]) return [];
      return decodeURIComponent(p[i + 2]).split('+').filter(Boolean);
    })();

    var ffgfParam = (function () {
      var out = {};
      var raw = new URLSearchParams(location.search).get('ffgf');
      if (!raw) return out;
      raw.split('|').forEach(function (chunk) {
        var i = chunk.indexOf(':');
        if (i === -1) return;
        out[chunk.slice(0, i)] = chunk.slice(i + 1).split('~').filter(Boolean);
      });
      return out;
    })();

    var state = {};
    var optsByGroup = {};
    dds.forEach(function (dd) {
      var g = dd.getAttribute('data-ffgf-group') || '';
      var opts = Array.prototype.slice.call(dd.querySelectorAll('.ffgf__opt[data-ffgf-tag]'));
      optsByGroup[g] = opts;
      if (ffgfParam[g] && ffgfParam[g].length) {
        /* a shared / reloaded ?ffgf= url is the authority for this axis */
        var want = ffgfParam[g];
        state[g] = opts.map(function (a) { return a.getAttribute('data-ffgf-tag'); })
          .filter(function (t) { return want.indexOf(t) !== -1; });
        return;
      }
      state[g] = opts.filter(function (a) {
        if (a.getAttribute('data-ffgf-on') === '1') return true;
        /* an active option's href is the REMOVE url, which deliberately omits
           its own tag - reading a handle off it would match the wrong option */
        if (a.classList.contains('is-active')) return false;
        return pathTags.indexOf(handleOf(a)) !== -1;
      }).map(function (a) { return a.getAttribute('data-ffgf-tag'); });
    });

    /* how many filters the page ARRIVED with - decides whether an empty
       selection is still something the shopper needs to be able to submit */
    var seededCount = Object.keys(state).reduce(function (n, g) { return n + state[g].length; }, 0);

    function labelOf(g, tag) {
      var a = (optsByGroup[g] || []).filter(function (o) { return o.getAttribute('data-ffgf-tag') === tag; })[0];
      return (a && a.getAttribute('data-ffgf-label')) || tag;
    }

    function totalSelected() {
      return Object.keys(state).reduce(function (n, g) { return n + state[g].length; }, 0);
    }
    function anyMulti() {
      return Object.keys(state).some(function (g) { return state[g].length > 1; });
    }

    /* ---- the query ------------------------------------------------------
       Returns {q, filterTags}. Axes with one value stay OUT of q on purpose:
       filter.p.tag is an exact match, tag:"X" is not. */
    function buildQuery() {
      /* Scope to the collection's OWN product types when it tells us what they
         are, falling back to the game's full list. Matching the handle against
         games.<key>.singles was tried and is WRONG: the nav links
         /collections/pkmn-in-stock while the games JSON calls it
         "pokemon-singles", so the match silently failed and a Pokemon singles
         search came back scoped to Pokemon Sealed as well. */
      var own = [root.dataset.ffgfPtypeFirst, root.dataset.ffgfPtypeLast]
        .filter(function (t) { return t; })
        .filter(function (t, i, a) { return a.indexOf(t) === i; });
      var types = own.length ? own : ((gameDef && gameDef.types) || []);
      var parts = [];
      if (types.length) {
        parts.push('(' + types.map(function (t) { return 'product_type:"' + t + '"'; }).join(' OR ') + ')');
      }
      var inQ = [];   /* [{tag, group}] - the group matters, see exclusions */
      var filterTags = [];
      Object.keys(state).forEach(function (g) {
        var sel = state[g];
        if (sel.length > 1) {
          parts.push('(' + sel.map(function (t) { return 'tag:"' + t + '"'; }).join(' OR ') + ')');
          sel.forEach(function (t) { inQ.push({ tag: t, group: g }); });
        } else if (sel.length === 1) filterTags.push(sel[0]);
      });

      /* Exclusions are PER AXIS, never across axes.
         The first cut tested every selected tag against the whole vocabulary,
         which deletes products that genuinely match: picking Energy Type
         "Fire" also matched the Yu-Gi-Oh set "Structure Deck: Fire Kings", so
         it emitted -tag:"Structure Deck: Fire Kings" and removed every card in
         that set - including the real Fire-attribute ones the shopper asked
         for. Silently fewer results, which is the worst kind of wrong.
         A false positive from another axis is a far smaller error than
         deleting true positives, so only same-axis children are excluded:
         "Aetherdrift" still drops "Aetherdrift Commander", which is the case
         exclusions exist for. */
      var allSelected = [];
      Object.keys(state).forEach(function (g) { allSelected = allSelected.concat(state[g]); });
      var excl = [];
      inQ.forEach(function (picked) {
        (optsByGroup[picked.group] || []).forEach(function (a) {
          var other = a.getAttribute('data-ffgf-tag');
          if (!other || allSelected.indexOf(other) !== -1 || excl.indexOf(other) !== -1) return;
          if (phraseContains(other, picked.tag)) excl.push(other);
        });
      });
      excl.forEach(function (t) { parts.push('-tag:"' + t + '"'); });
      return { q: parts.join(' '), filterTags: filterTags };
    }

    function searchUrl() {
      var built = buildQuery();
      var p = new URLSearchParams();
      p.set('type', 'product');
      p.set('q', built.q);
      built.filterTags.forEach(function (t) { p.append('filter.p.tag', t); });
      /* Every singles collection in this nav is in-stock-scoped, and the search
         page's own "In stock only" toggle already defaults ON (readInstockPref).
         Carrying it over keeps the result set the shopper was looking at; they
         can untick it on the results page. Deciding this from the handle was
         the bug above, so it is no longer conditional on one. */
      /* Always, when LEAVING A COLLECTION. Reading localStorage made it
         unpredictable - an in-stock-only collection could hand back
         out-of-stock results depending on a preference set elsewhere. Every
         singles collection in this nav is in-stock-scoped, and the shopper can
         untick "In stock only" on the results page. */
      p.append('filter.v.availability', '1');
      return '/search?' + p.toString();
    }

    function tagPathUrl() {
      var handles = [];
      Object.keys(state).forEach(function (g) {
        state[g].forEach(function (tag) {
          var a = optsByGroup[g].filter(function (o) { return o.getAttribute('data-ffgf-tag') === tag; })[0];
          var h = a && handleOf(a);
          if (h && handles.indexOf(h) === -1) handles.push(h);
        });
      });
      return base + (handles.length ? '/' + handles.join('+') : '') + qs;
    }

    /* Wired to the in-place loader. Falls back to a real navigation only if
       that layer could not attach (no product-grid section on the page). */
    var inPlace = null;
    try { inPlace = ffInPlace({ base: base, qs: qs }); } catch (e) { inPlace = null; }

    function selectedHandles() {
      var handles = [];
      Object.keys(state).forEach(function (g) {
        state[g].forEach(function (tag) {
          var a = optsByGroup[g].filter(function (o) { return o.getAttribute('data-ffgf-tag') === tag; })[0];
          var h = a && handleOf(a);
          if (h && handles.indexOf(h) === -1) handles.push(h);
        });
      });
      return handles;
    }

    function apply() {
      if (inPlace) { inPlace.apply(state, selectedHandles(), anyMulti(), buildQuery()); return; }
      location.href = anyMulti() ? searchUrl() : tagPathUrl();
    }

    /* ---- UI -------------------------------------------------------------
       Each option becomes a checkbox row. The <a> and its href stay exactly as
       they were, so with JS off, or if this throws, the bar is still today's
       working single-select bar. */
    function paint() {
      dds.forEach(function (dd) {
        var g = dd.getAttribute('data-ffgf-group') || '';
        var sel = state[g] || [];
        optsByGroup[g].forEach(function (a) {
          var on = sel.indexOf(a.getAttribute('data-ffgf-tag')) !== -1;
          a.classList.toggle('ffgf__opt--checked', on);
          a.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var val = dd.querySelector('.ffgf__summary-value');
        var text = sel.length === 0 ? '' : (sel.length === 1 ? labelOf(g, sel[0]) : sel.length + ' selected');
        if (!val && text) {
          val = document.createElement('span');
          val.className = 'ffgf__summary-value';
          var caret = dd.querySelector('.ffgf__caret');
          dd.querySelector('.ffgf__summary').insertBefore(val, caret || null);
        }
        if (val) val.textContent = text;
        dd.classList.toggle('has-value', sel.length > 0);
      });
      var n = totalSelected();
      /* The bar must survive going to ZERO whenever the page ARRIVED filtered,
         or there is no way to take a filter off: Apply and Clear both live in
         here, and unticking the last box used to hide them while the page was
         still filtered. Apply at zero is already correct - it takes the
         non-multi branch to tagPathUrl(), which is the bare collection. */
      bar.hidden = n === 0 && seededCount === 0;
      count.textContent = n === 0 ? 'No filters' : (n === 1 ? '1 filter' : n + ' filters');
      go.textContent = n === 0 ? 'Show all' : 'Apply filters';
      note.hidden = !anyMulti();
    }

    dds.forEach(function (dd) {
      var g = dd.getAttribute('data-ffgf-group') || '';
      dd.classList.add('ffgf__dd--multi');
      optsByGroup[g].forEach(function (a) {
        a.setAttribute('role', 'button');
        a.insertBefore(Object.assign(document.createElement('span'), { className: 'ffgf__tick' }), a.firstChild);
        a.addEventListener('click', function (ev) {
          /* let a modified click still open the single-filter link in a new tab */
          if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0) return;
          ev.preventDefault();
          var tag = a.getAttribute('data-ffgf-tag');
          var i = state[g].indexOf(tag);
          if (i === -1) state[g].push(tag); else state[g].splice(i, 1);
          paint();
        });
      });
    });

    /* apply / clear bar */
    var bar = document.createElement('div');
    bar.className = 'ffgf__apply';
    bar.hidden = true;
    var count = document.createElement('span');
    count.className = 'ffgf__apply-count';
    var go = document.createElement('button');
    go.type = 'button';
    go.className = 'ffgf__apply-btn';
    go.textContent = 'Apply filters';
    go.addEventListener('click', apply);
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'ffgf__apply-clear';
    clear.textContent = 'Clear';
    clear.addEventListener('click', function () {
      Object.keys(state).forEach(function (g) { state[g] = []; });
      /* if the page is already filtered, Clear has to NAVIGATE - repainting
         alone left the ticks disagreeing with the products on screen */
      if (seededCount) { apply(); return; }
      paint();
    });
    var note = document.createElement('span');
    note.className = 'ffgf__apply-note';
    note.hidden = true;
    note.textContent = 'Picking more than one in a box searches for either';
    bar.appendChild(count); bar.appendChild(note); bar.appendChild(clear); bar.appendChild(go);
    root.appendChild(bar);

    /* Enter applies - but ONLY from the apply bar itself. Bound on .ffgf it
       swallowed Enter everywhere, which is how the <summary> elements are
       opened and how the snippet's own in-panel "Search sets" box picks the
       first match. */
    bar.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); apply(); }
    });

    paint();

    /* A cold load of a shared ?ffgf= url rendered the UNFILTERED collection
       server-side, so the view has to be fetched once. replaceState, not push,
       or the shopper gets a duplicate history entry to back through. */
    if (inPlace && Object.keys(ffgfParam).length && totalSelected()) {
      inPlace.apply(state, selectedHandles(), anyMulti(), buildQuery(), true);
    }

    /* Back/forward must move the products, not just the address bar. A reload
       is heavier than re-painting but it is always correct, and it only fires
       on an actual history move.
       FF p-63: "an actual history move" means the PATH or QUERY changed. A
       fragment-only move fires popstate too - the skip-to-content link
       (#MainContent), any #anchor link, setting location.hash - and each one
       reloaded the whole collection (measured on the draft 2026-10-13, 1536
       and 375: Tab, Enter on the skip link = a full reload).
       The yardstick is the url the products on screen belong to: this load,
       or the last pushState/replaceState from ANY caller. Not only ours:
       Dawn's Sort by pushes too (facets.js updateURLHash), and a Back past a
       sort we had not seen would look fragment-only and leave the sorted grid
       under an unsorted url.
       A fragment-only move also stops the event. facets.js listens for
       popstate as well and, on one of our {ffgf} entries, re-renders
       '?section_id=...&undefined' - measured, that painted the UNFILTERED
       collection (25,000+) under a Mythic + Rare url and ticks. This listener
       is registered before facets.js's (ff-search.js loads in the header,
       facets.js in the grid section, both defer) and the window runs popstate
       listeners in that order - measured, this slot fires first - so stopping
       here keeps facets.js out. When only the fragment moved there is nothing
       on the page to redraw.
       If the wrap cannot be installed, every popstate reloads, as before. */
    var ffShownUrl = location.pathname + location.search;
    var ffShownTracked = false;
    try {
      ['pushState', 'replaceState'].forEach(function (m) {
        var orig = history[m];
        if (typeof orig !== 'function') throw new Error('history.' + m);
        var wrapped = function () {
          var out = orig.apply(this, arguments);
          ffShownUrl = location.pathname + location.search;
          return out;
        };
        history[m] = wrapped;
        if (history[m] !== wrapped) throw new Error('history.' + m);
      });
      ffShownTracked = true;
    } catch (e) { /* untracked: reload on every popstate, as before */ }
    window.addEventListener('popstate', function (ev) {
      if (ffShownTracked && location.pathname + location.search === ffShownUrl) {
        ev.stopImmediatePropagation();
        return;
      }
      location.reload();
    });
  }

  try { ffMulti(); } catch (e) { /* the bar keeps working as single-select */ }

  /* 7. MULTI-SELECT on the SEARCH RESULTS page.
     ------------------------------------------------------------------
     Same problem, same answer as the collection bar above, but the controls
     here are ff-search.js's own single-value <select>s and set picker, which
     write one filter.p.tag per axis. Rather than rewrite those (the search page
     is the most-used surface and a regression there is worse than the missing
     feature), this renders its OWN multi-select bar from the same
     ff-sets-<game>.json and hides the single-value controls ONLY once its own
     bar is on the page. Anything thrown leaves the page exactly as it is today.

     The shopper's typed words are preserved: q is split into the clauses we
     generate and everything else, and "everything else" is put back verbatim. */
  function ffMultiSearch() {
    if (!/\/search/.test(location.pathname)) return;
    var picker = document.querySelector('[data-ff-setpick][data-ff-apply-on-change]');
    var groupsEl = document.querySelector('[data-ff-groups][data-ff-apply-on-change]');
    if (!picker || document.querySelector('.ffgf--search')) return;

    /* data-ff-game is rendered server-side from filter.p.product_type, so it is
       EMPTY on exactly the urls the collection bar produces - those carry the
       scope as (product_type:"X") inside q instead. Resolve it from whichever
       form is present rather than trusting the attribute. */
    var sp0 = new URLSearchParams(location.search);
    var scopeTypes = sp0.getAll('filter.p.product_type');
    ((sp0.get('q') || '').match(/product_type:"([^"]*)"/g) || []).forEach(function (m) {
      var t = m.slice(14, -1);
      if (scopeTypes.indexOf(t) === -1) scopeTypes.push(t);
    });
    var gameKey = picker.getAttribute('data-ff-game') || '';
    if (!gameKey && scopeTypes.length) {
      for (var gi = 0; gi < games.length; gi++) {
        if ((games[gi].types || []).some(function (t) { return scopeTypes.indexOf(t) !== -1; })) { gameKey = games[gi].key; break; }
      }
    }
    if (!gameKey) return;
    var urls = {};
    try { urls = JSON.parse(picker.getAttribute('data-ff-sets-urls') || '{}'); } catch (e) { return; }
    if (!urls[gameKey]) return;

    fetch(urls[gameKey]).then(function (r) { return r.json(); }).then(function (data) {
      try { render(data); } catch (e) { /* leave the stock controls alone */ }
    }).catch(function () { /* same */ });

    function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function phraseContains(h, n) {
      var H = ' ' + norm(h) + ' ', N = ' ' + norm(n) + ' ';
      return H !== N && H.indexOf(N) !== -1;
    }
    function tagOf(v) { return v.t || v.l; }

    function render(data) {
      var axes = [];
      if ((data.sets || []).length) axes.push({ g: 'Set', v: data.sets });
      (data.groups || []).forEach(function (grp) { if ((grp.v || []).length) axes.push({ g: grp.g, v: grp.v }); });
      if (!axes.length) return;

      var vocabulary = [];
      axes.forEach(function (a) { a.v.forEach(function (v) { var t = tagOf(v); if (t && vocabulary.indexOf(t) === -1) vocabulary.push(t); }); });

      /* ---- read the current URL back into axis state --------------------- */
      var sp = new URLSearchParams(location.search);
      var rawQ = sp.get('q') || '';
      var selected = [];
      /* OR-groups we previously wrote */
      var orRe = /\((?:\s*tag:"[^"]*"\s*(?:OR\s*)?)+\)/g;
      var mo;
      while ((mo = orRe.exec(rawQ))) {
        (mo[0].match(/tag:"([^"]*)"/g) || []).forEach(function (bit) {
          selected.push(bit.slice(5, -1));
        });
      }
      /* exact single-value axes */
      sp.getAll('filter.p.tag').forEach(function (t) { if (selected.indexOf(t) === -1) selected.push(t); });

      /* everything in q that is NOT ours is the shopper's own words */
      var freeText = rawQ
        .replace(orRe, ' ')
        .replace(/-tag:"[^"]*"/g, ' ')
        .replace(/\(\s*product_type:"[^"]*"(?:\s+OR\s+product_type:"[^"]*")*\s*\)/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      /* the product_type scope exactly as it was - never regenerated */
      var typeClause = (rawQ.match(/\(\s*product_type:"[^"]*"(?:\s+OR\s+product_type:"[^"]*")*\s*\)/) || [''])[0];

      var state = {};
      axes.forEach(function (a) {
        state[a.g] = a.v.map(tagOf).filter(function (t) { return selected.indexOf(t) !== -1; });
      });

      var seededCount = axes.reduce(function (n, a) { return n + state[a.g].length; }, 0);

      function anyMulti() { return axes.some(function (a) { return state[a.g].length > 1; }); }
      function total() { return axes.reduce(function (n, a) { return n + state[a.g].length; }, 0); }

      function buildUrl() {
        var parts = [];
        if (typeClause) parts.push(typeClause);
        var inQ = [], filterTags = [], orClauses = [], all = [];
        axes.forEach(function (a) { all = all.concat(state[a.g]); });
        axes.forEach(function (a) {
          var s = state[a.g];
          if (s.length > 1) { orClauses.push('(' + s.map(function (t) { return 'tag:"' + t + '"'; }).join(' OR ') + ')'); s.forEach(function (t) { inQ.push({ tag: t, group: a.g }); }); }
          else if (s.length === 1) filterTags.push(s[0]);
        });
        /* Bare words next to a parenthesised OR group WIDEN the search instead
           of narrowing it - measured on this store 2026-10-08:
             charizard                              328
             charizard (tag:"Fire" OR tag:"Water")  1000  (capped - wider)
             "charizard" (tag:"Fire" OR tag:"Water") 145  (correctly narrower)
           A quoted phrase binds, so the shopper's words are quoted ONLY when an
           OR group is present. The cost is prefix matching on those words, which
           is why this is not done when there is nothing to bind them against. */
        if (freeText) {
          /* re-reading our own url hands back the quoted form, so unwrap first
             and re-decide - otherwise the quotes stick after the shopper drops
             back to one value and they silently lose prefix matching */
          var bare = freeText.replace(/^"(.*)"$/, '$1');
          parts.push(orClauses.length ? '"' + bare.replace(/"/g, '') + '"' : bare);
        }
        orClauses.forEach(function (c) { parts.push(c); });
        /* PER AXIS, never across axes - see the collection bar for why:
           excluding a SET because it contains the word of a selected Energy
           Type deletes the real matches inside that set. */
        var excl = [];
        inQ.forEach(function (picked) {
          var ax = axes.filter(function (a) { return a.g === picked.group; })[0];
          (ax ? ax.v : []).forEach(function (v) {
            var other = tagOf(v);
            if (!other || all.indexOf(other) !== -1 || excl.indexOf(other) !== -1) return;
            if (phraseContains(other, picked.tag)) excl.push(other);
          });
        });
        excl.forEach(function (t) { parts.push('-tag:"' + t + '"'); });
        var p = new URLSearchParams();
        p.set('type', 'product');
        p.set('q', parts.join(' ').trim() || '*');
        filterTags.forEach(function (t) { p.append('filter.p.tag', t); });
        /* carry every non-tag facet the shopper already had */
        sp.forEach(function (val, key) {
          if (key === 'q' || key === 'type' || key === 'filter.p.tag' || key === 'page') return;
          p.append(key, val);
        });
        return location.pathname + '?' + p.toString();
      }

      /* ---- markup: same classes as the collection bar, so one stylesheet -- */
      var root = document.createElement('div');
      root.className = 'ffgf ffgf--search';
      var barEl = document.createElement('div');
      barEl.className = 'ffgf__bar';
      root.appendChild(barEl);

      var paints = [];
      axes.forEach(function (a) {
        var dd = document.createElement('details');
        dd.className = 'ffgf__dd ffgf__dd--multi';
        var sum = document.createElement('summary');
        sum.className = 'ffgf__summary';
        var lbl = document.createElement('span');
        lbl.className = 'ffgf__summary-label';
        lbl.textContent = a.g;
        var valEl = document.createElement('span');
        valEl.className = 'ffgf__summary-value';
        sum.appendChild(lbl); sum.appendChild(valEl);
        dd.appendChild(sum);
        var panel = document.createElement('div');
        panel.className = 'ffgf__panel';
        /* MTG ships 584 sets. The two controls this replaces both had a way to
           narrow the list (the stock Set field is a typed input with a
           datalist), so a bare 584-row scroll would be a regression. */
        var find = null;
        if (a.v.length > 8) {
          find = document.createElement('input');
          find.className = 'ffgf__search';
          find.type = 'search';
          find.setAttribute('autocomplete', 'off');
          find.placeholder = 'Search ' + a.g.toLowerCase();
          find.setAttribute('aria-label', 'Search ' + a.g.toLowerCase());
          panel.appendChild(find);
        }
        var ul = document.createElement('ul');
        ul.className = 'ffgf__list';
        ul.setAttribute('role', 'list');
        var rows = [];
        a.v.forEach(function (v) {
          var tag = tagOf(v);
          var li = document.createElement('li');
          var btn = document.createElement('a');
          btn.className = 'ffgf__opt';
          btn.setAttribute('role', 'button');
          btn.href = '#';
          btn.appendChild(Object.assign(document.createElement('span'), { className: 'ffgf__tick' }));
          btn.appendChild(document.createTextNode(v.l || tag));
          btn.addEventListener('click', function (ev) {
            ev.preventDefault();
            var i = state[a.g].indexOf(tag);
            if (i === -1) state[a.g].push(tag); else state[a.g].splice(i, 1);
            paintAll();
          });
          li.appendChild(btn); ul.appendChild(li);
          rows.push({ tag: tag, el: btn, label: v.l || tag });
        });
        panel.appendChild(ul);
        if (find) {
          find.addEventListener('input', function () {
            var needle = find.value.trim().toLowerCase();
            rows.forEach(function (r) {
              r.el.parentNode.hidden = needle !== '' && r.label.toLowerCase().indexOf(needle) === -1;
            });
          });
          /* keep Enter inside the box from reaching the apply bar */
          find.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') ev.preventDefault(); });
        }
        dd.appendChild(panel);
        barEl.appendChild(dd);
        paints.push(function () {
          var s = state[a.g];
          rows.forEach(function (r) { r.el.classList.toggle('ffgf__opt--checked', s.indexOf(r.tag) !== -1); });
          var lblTxt = s.length === 0 ? '' : (s.length === 1
            ? (rows.filter(function (r) { return r.tag === s[0]; })[0] || { label: s[0] }).label
            : s.length + ' selected');
          valEl.textContent = lblTxt;
          dd.classList.toggle('has-value', s.length > 0);
        });
      });

      var apply = document.createElement('div');
      apply.className = 'ffgf__apply';
      var cnt = document.createElement('span');
      cnt.className = 'ffgf__apply-count';
      var note = document.createElement('span');
      note.className = 'ffgf__apply-note';
      note.textContent = 'Picking more than one in a box searches for either';
      var clear = document.createElement('button');
      clear.type = 'button'; clear.className = 'ffgf__apply-clear'; clear.textContent = 'Clear';
      clear.addEventListener('click', function () {
        axes.forEach(function (a) { state[a.g] = []; });
        if (seededCount) { location.href = buildUrl(); return; }
        paintAll();
      });
      var go = document.createElement('button');
      go.type = 'button'; go.className = 'ffgf__apply-btn'; go.textContent = 'Apply filters';
      go.addEventListener('click', function () { location.href = buildUrl(); });
      apply.appendChild(cnt); apply.appendChild(note); apply.appendChild(clear); apply.appendChild(go);
      root.appendChild(apply);

      function paintAll() {
        paints.forEach(function (fn) { fn(); });
        var n = total();
        /* keep Apply reachable at zero when the page arrived filtered, or the
           shopper cannot take the filter back off */
        apply.hidden = n === 0 && seededCount === 0;
        cnt.textContent = n === 0 ? 'No filters' : (n === 1 ? '1 filter' : n + ' filters');
        go.textContent = n === 0 ? 'Show all' : 'Apply filters';
        note.hidden = !anyMulti();
      }

      /* only now, with a working bar in hand, retire the single-value ones */
      picker.parentNode.insertBefore(root, picker);
      function retire() {
        picker.hidden = true;
        if (groupsEl) groupsEl.hidden = true;
      }
      retire();
      /* Dawn's facets.js re-renders the section on every facet click and
         rebuilds these nodes from server markup, which drops the hidden flag -
         the stock Set field and group selects came back and the page carried
         two disagreeing filter UIs. Re-apply whenever the subtree changes, and
         re-insert our own bar if the re-render detached it. */
      try {
        var host = picker.parentNode;
        new MutationObserver(function () {
          var p = document.querySelector('[data-ff-setpick][data-ff-apply-on-change]');
          var g = document.querySelector('[data-ff-groups][data-ff-apply-on-change]');
          if (p && !p.hidden) p.hidden = true;
          if (g && !g.hidden) g.hidden = true;
          if (!root.isConnected && p && p.parentNode) p.parentNode.insertBefore(root, p);
        }).observe(host, { childList: true, subtree: true });
      } catch (e) { /* observer is a nicety, not a requirement */ }
      paintAll();
    }
  }

  try { ffMultiSearch(); } catch (e) { /* stock search controls stay */ }
})();